import React from "react";
import PropTypes from 'prop-types';
import {Grid, Paper, Typography} from "@material-ui/core";
import TextField from "../Fields/TextField";
import useStyles from "../../styles/styles";

const LeadPurchaseMarketingRedirectInformation = ({marketingRedirects}) => {
    const classes = useStyles();

    return (
        <>
            <Typography variant="h4" component="h4" align="left" id={"lead-purchase-marketing-redirects"}>Lead Purchase Marketing Redirects</Typography>
            {marketingRedirects.map (marketingRedirect => (
                <Paper className={classes.paper}>
                    <Grid container spacing={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={6}>
                                <TextField label="Pop-under Url" value={marketingRedirect.popunderUrl}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <TextField label="Local Url" value={marketingRedirect.localUrl}/>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            ))}
        </>
    )
};

LeadPurchaseMarketingRedirectInformation.propTypes = {
    marketingRedirect: PropTypes.shape({
        id: PropTypes.string,
        leadPurchaseRequestId: PropTypes.string,
        popunderUrl: PropTypes.string,
        localUrl: PropTypes.string,
    }),
};

LeadPurchaseMarketingRedirectInformation.defaultProps = {
    decision: {},
};

export default LeadPurchaseMarketingRedirectInformation;
